import screenWidthPlugin from './screenWidthPlugin'

function pluginFn(siteAPI, compLayoutRelativeToStructure, compProps) {
    return compProps.alignmentType === 'fullWidth' ? screenWidthPlugin(siteAPI, compLayoutRelativeToStructure) : {}
}

export default pluginFn
